module.exports = {
  // Parser parse data failed
  PARSER_ERROR: 5200,
};
